import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataApiResponse, EntryOrder, ProductGroup } from '@digilize/shared/definitions/src';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProductGroupsApiService {
  constructor(private http: HttpClient) {}
  readonly BASE_URL = '/api/v1.0/product-groups';

  getGroups(params?): Observable<DataApiResponse<ProductGroup[]>> {
    return this.http.get<DataApiResponse<ProductGroup[]>>(`${this.BASE_URL}`, { params });
  }

  addGroup(
    productGroup: Pick<ProductGroup, 'description' | 'name' | 'colors' | 'company_id' | 'photo_id'>
  ): Observable<ProductGroup> {
    return this.http.post<ProductGroup>(`${this.BASE_URL}`, productGroup);
  }

  editGroup(productGroup: ProductGroup): Observable<ProductGroup> {
    return this.http.put<ProductGroup>(`${this.BASE_URL}`, productGroup);
  }

  getGroupById(groupId: string): Observable<ProductGroup> {
    return this.http.get<ProductGroup>(`${this.BASE_URL}/${groupId}`);
  }

  deleteGroup(groupId: string): Observable<void> {
    return this.http.delete<void>(`${this.BASE_URL}/${groupId}`);
  }

  updateGroupsOrder(orderData: EntryOrder[]): Observable<any> {
    return this.http.post<any>(`${this.BASE_URL}/order`, { groups: orderData });
  }

  updateGroupOrder(id: string, orderData: EntryOrder[]): Observable<any> {
    return this.http.post<any>(`${this.BASE_URL}/${id}/order`, { products: orderData });
  }
  deleteProductsFromGroup(id: string, products: string[]): Observable<any> {
    return this.http.delete<any>(`${this.BASE_URL}/${id}/products`, { body: { product_ids: products } });
  }
}
